/*
  TODO: this is a placeholder until we get url params into the hosted app
*/
const useSandboxMode = () => ({ isSandbox: true });

export default useSandboxMode;
